var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import { FlowNode, flowNodeColor, NodeTypeComponent, } from 'fable/flowEditor';
import { ForwardModal as ActionModal } from '../modals/forward';
import { CallPattern } from '../types';
const portTranslator = (node) => {
    if (node.payload.noAnswerNodeId) {
        return [
            {
                id: uuid(),
                type: 'out',
                label: 'No answer',
                connection: node.payload.noAnswerNodeId,
            },
        ];
    }
    return [];
};
export class ForwardNode extends NodeTypeComponent() {
    triggerEdit() {
        const { onEdit, node } = this.props;
        onEdit(node, node.nodeType);
    }
    getCallPatternName(pattern) {
        switch (pattern) {
            case CallPattern.Sequence:
                return 'Sequence';
            default:
                return 'First to pick up';
        }
    }
    render() {
        const { node: { payload: { callPattern, numbers }, }, } = this.props;
        return (_jsx(FlowNode, { color: ForwardNode.color, icon: ForwardNode.icon, label: ForwardNode.label, text: _jsxs("span", { children: ["Call pattern ", _jsx("strong", { children: this.getCallPatternName(callPattern) }), ", to", ' ', _jsxs("strong", { children: [numbers.length, " ", numbers.length === 1 ? 'phone' : 'phones'] })] }), onEdit: this.triggerEdit }));
    }
}
ForwardNode.icon = 'phone-outgoing';
ForwardNode.label = 'Forward';
ForwardNode.helpText = 'Set up incoming calls to be forwarded to internal or external phone numbers.';
ForwardNode.color = flowNodeColor.green;
ForwardNode.translatePayload = formatPortsHelper(portTranslator);
ForwardNode.ActionModal = ActionModal;
ForwardNode.actionTrigger = { type: FlowNodeTypes.FORWARD };
ForwardNode.updateConnection = (node, port, newConnection) => {
    const payload = Object.assign({}, node.payload);
    if (port.label === 'No answer') {
        payload.noAnswerNodeId = newConnection;
    }
    return Object.assign(Object.assign({}, node), { payload });
};
__decorate([
    boundMethod
], ForwardNode.prototype, "triggerEdit", null);
__decorate([
    boundMethod
], ForwardNode.prototype, "getCallPatternName", null);
